module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=MH - Marshall Islands.d1c4a7f6.svg";